import { PropsWithChildren, ReactNode } from 'react';

import { Restore, Save } from '@mui/icons-material';
import { Button, DialogContentText } from '@mui/material';

import { ActionButtons, DeleteButton, LogButton } from 'components';
import { AppDialog } from 'components/Dialogs';
import strings from 'constants/index';
import { useDialogStatus } from 'hooks/common';

interface DetailActionsProps extends PropsWithChildren<any> {
  isResetDisabled?: boolean;
  isSaveDisabled?: boolean;
  isSaveHidden?: boolean;
  onReset?: () => void;
  onSubmit?: () => void;
  entityName: string;
  logsUrl?: string;
  entityNameMappings?: Record<string, string>;
  onDelete?: () => Promise<void>;
  deleteButton?: ReactNode;
}

const DetailsActions = ({
  isResetDisabled,
  isSaveDisabled,
  isSaveHidden,
  entityName,
  logsUrl,
  entityNameMappings,
  deleteButton,
  onDelete,
  onReset,
  onSubmit,
}: DetailActionsProps) => {
  const { isOpen, onShow, onHide } = useDialogStatus();
  const isLineupLogs = logsUrl?.includes('/lineups/');
  return (
    <>
      <ActionButtons>
        {onReset && (
          <Button
            data-testid="reset"
            onClick={onShow}
            variant="contained"
            disabled={isResetDisabled}
            startIcon={<Restore />}
          >
            {strings.reset}
          </Button>
        )}
        {onSubmit && !isSaveHidden && (
          <Button
            data-testid="save"
            onClick={onSubmit}
            variant="contained"
            disabled={isSaveDisabled}
            startIcon={<Save />}
          >
            {strings.save}
          </Button>
        )}
        {logsUrl && (
          <LogButton
            entityName={entityName}
            additionalSpecialProperties={isLineupLogs ? ['Lineup', 'LineupId', 'TrackerKey'] : []}
            logsUrl={logsUrl}
            entityNameMappings={entityNameMappings}
          />
        )}
        {deleteButton
          ? deleteButton
          : onDelete && <DeleteButton entityName={entityName} onDelete={onDelete} />}
      </ActionButtons>
      {onReset && (
        <AppDialog
          open={isOpen}
          title={strings.warning}
          fullWidth={false}
          onClose={onHide}
          confirmButton={{
            label: strings.discard,
            props: {
              onClick: () => {
                onReset();
                onHide();
              },
            },
          }}
        >
          <DialogContentText>{strings.unsaved_changes}</DialogContentText>
        </AppDialog>
      )}
    </>
  );
};

export default DetailsActions;
